<template>
  <a :href="link" class="position-absolute shop-now" :style="{width: `${width}%`, display: 'inline-block'}" target="_blank">
    <img :src="img" alt="" class="w-100">
  </a>
</template>

<script>
export default {
  name: "ShopNow",
  props: {
    width: {
      type: Number,
      default: 10
    },
    link: {
      type: String,
      default: '#'
    }
  },
  data() {
    return {
      img: require('../assets/img/shopnow.png')
    }
  }
}
</script>

<style scoped>

</style>